import dayjs from "dayjs";
import logo from "../../../../assets/images/logo_light.svg";
import reportHeader from "../../../../assets/images/report_header.svg";
import { formatAmount } from "../../../../utils/appUtils";
const MAX_ROWS_PER_PAGE = 9;

const GstInvoiceReport = ({
    data = [],
    reportTitle = "SELF TAX INVOICE REPORTS",
    invoiceNoLabel = "INV No",
    supplierOfServiceLabel = "Supplier of Service",
    summary = {},
    gstin = "33AAUCM1496R1ZG"
}) => {
    const totalTaxableValue = Number(summary?.totalTaxableValue) || 0;
    const totalInvoiceValue = Number(summary?.totalInvoiceValue) || 0;
    const totalGstValue = Number(summary?.totalGstValue) || 0;
    const totalInvoiceCount = Number(summary?.totalInvoiceCount) || 0;
    const taxableColumnLabel = "Taxable Value";
    const gstColumnLabel = "GST (18%)";
    const totalColumnLabel = "Total INV Value";
    const paginatedRows = data?.length
        ? Array.from({ length: Math.ceil(data?.length / MAX_ROWS_PER_PAGE) }, (_, pageIndex) => {
            const startIndex = pageIndex * MAX_ROWS_PER_PAGE;
            const endIndex = startIndex + MAX_ROWS_PER_PAGE;
            return data?.slice(startIndex, endIndex);
        })
        : [[]];

    return (
        <div className="tax-invoice-report">
            {
                paginatedRows?.map((pageRows, pageIndex) => {
                    const pageTotalTaxableValue = pageRows?.reduce((accumulator, detail) => accumulator + (Number(detail?.taxableValue) || 0), 0);
                    const pageTotalGstValue = pageRows?.reduce((accumulator, detail) => accumulator + (Number(detail?.gstValue) || 0), 0);
                    const pageTotalInvoiceValue = pageRows?.reduce((accumulator, detail) => accumulator + (Number(detail?.totalInvoiceValue) || 0), 0);

                    return <div key={`${pageIndex}`} className="tax-report-page">
                        <div className="tax-report-sheet">
                            <div className="tax-report-header">
                                <div className="tax-report-branding">
                                    <img src={logo} alt="MLawyer" />
                                    <div className="tax-report-brand-text">
                                        <h1>MLawyer</h1>
                                        <h3>GSTIN: {gstin}</h3>
                                    </div>
                                </div>
                                <div className="tax-report-header-shape" aria-hidden="true">
                                    <img src={reportHeader} alt="" />
                                </div>
                            </div>
                            <h2 className="tax-report-title">{reportTitle}</h2>
                            <div className="tax-report-summary-strip">
                                <div className="tax-report-summary-item">
                                    <p>Total INV Count</p>
                                    <h4>{formatAmount(totalInvoiceCount)}</h4>
                                </div>
                                <div className="tax-report-summary-item">
                                    <p>Total Taxable Value</p>
                                    <h4>₹{formatAmount(totalTaxableValue)}</h4>
                                </div>
                                <div className="tax-report-summary-item">
                                    <p>Total GST Value</p>
                                    <h4>₹{formatAmount(totalGstValue)}</h4>
                                </div>
                                <div className="tax-report-summary-item">
                                    <p>Total INV Value</p>
                                    <h4>₹{formatAmount(totalInvoiceValue)}</h4>
                                </div>
                            </div>
                            <div className="tax-report-table-wrapper">
                                <div className="tax-report-watermark" aria-hidden="true">
                                    <img src={logo} alt="" />
                                </div>
                                <table className="tax-report-table">
                                    <thead>
                                        <tr>
                                            <th>SNo</th>
                                            <th>Date</th>
                                            <th>{invoiceNoLabel}</th>
                                            <th>{supplierOfServiceLabel}</th>
                                            <th>Description</th>
                                            <th>{taxableColumnLabel}</th>
                                            <th>{gstColumnLabel}</th>
                                            <th>{totalColumnLabel}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            pageRows?.map((detail, rowIndex) => {
                                                const serialNumber = (pageIndex * MAX_ROWS_PER_PAGE) + rowIndex + 1;
                                                return <tr key={detail?.id || `${pageIndex}-${rowIndex}`}>
                                                    <td>{serialNumber}</td>
                                                    <td>{detail?.date ? dayjs(detail?.date).format("DD MMM,YYYY") : "Nil"}</td>
                                                    <td>{detail?.invoiceNumber || "Nil"}</td>
                                                    <td>{detail?.supplierOfService || "Nil"}</td>
                                                    <td>{detail?.description || "Nil"}</td>
                                                    <td>₹{formatAmount(detail?.taxableValue)}</td>
                                                    <td>₹{formatAmount(detail?.gstValue)}</td>
                                                    <td>₹{formatAmount(detail?.totalInvoiceValue)}</td>
                                                </tr>;
                                            })
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={5} className="tax-report-total-label">Total</td>
                                            <td>₹{formatAmount(pageTotalTaxableValue)}</td>
                                            <td>₹{formatAmount(pageTotalGstValue)}</td>
                                            <td>₹{formatAmount(pageTotalInvoiceValue)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>;
                })
            }
        </div>
    );
};

export default GstInvoiceReport;
